import React from 'react';
import { logDeprecation } from '../../../util/logging';
// eslint-disable-next-line zillow/import/no-named-default
import { CollapseOutlineSVG, default as CollapseOutline } from './IconCollapseOutline';
export var MinimizeOutlineSVG = CollapseOutlineSVG;
var MinimizeOutline = function MinimizeOutline(props) {
  logDeprecation("`IconMinimizeOutline` has been deprecated, use `IconCollapseOutline`");
  return /*#__PURE__*/React.createElement(CollapseOutline, props);
};
MinimizeOutline.displayName = 'IconMinimizeOutline';
export default MinimizeOutline;